//////////////////////////////////////////////////////////
//                                                      //   
//  PARA CLIENTES:                                      //   
//                                                      //   
//  APARECE COMO CARD PARA PREENCHIMENTO DE             //   
//  INFORMAÇÕES DO CARTÃO  NA PÁGINA DE CHECKOUT        //   
//                                                      //   
//  FUNCIONALIDADE: REALIZAR O PAGAMENTO DO PEDIDO      //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/checkout.js                                  //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import React, {useState, useEffect} from "react"

import MaskedInput from 'react-text-mask'
import jQuery from 'jquery'

import api from "../services/api";

function FormCartao(props){

  // ESTADOS DEFINIDOS
    // 'disabledbtn' = BOOLEANO QUE DEFINE SE O BOTÃO DE FINALIZAR VAI APARECER OU NÃO (SOME ENQUANTO O PEDIDO ESTÁ SENDO PROCESSADO)
    // 'dadosUsuario' = DADOS DO USUÁRIO PARA PREENCHIMENTO AUTOMÁTICO

    let [disabledbtn, setDisabledbtn] = useState(false)
    let [dadosUsuario, setDadosUsuario] = useState(null)
  
    window.itens = []
    for (var i = 0; i < props.props.length; i++){  // DEFINE OS ITENS QUE ESTÃO SENDO COMPRADOS
        var item = {}
        var id = props.props[i].id
        var prod = props.props[i][id]
        item['id'] = id
        item['description'] = 'produto'
        item['amount'] = parseFloat(prod.preco).toFixed(2)
        item['quantity'] = prod.carrinho

        window.itens.push({'item': item})
    }

    // CARREGA DADOS DO USUÁRIO PARA PREENCHIMENTO AUTOMÁTICO
    useEffect(() => {
        async function carregarDadosUsuario() {
            if (sessionStorage['login'] && !sessionStorage['login'].includes('/')) {
                // SÓ BUSCA DADOS SE FOR USUÁRIO (NÃO FRANQUEADO)
                try {
                    var resp = await api.post('buscar_dados_usuario', {
                        "usuario_id": sessionStorage['login']
                    });
                    
                    if (resp.data && resp.data.success) {
                        setDadosUsuario(resp.data.data);
                        preencherCampos(resp.data.data);
                    }
                } catch (error) {
                    console.log('Erro ao buscar dados do usuário:', error);
                }
            }
        }
        
        // PEQUENO DELAY PARA GARANTIR QUE OS ELEMENTOS DOM EXISTAM
        setTimeout(carregarDadosUsuario, 500);
    }, []);

    function preencherCampos(dados) {
        // FUNÇÃO PARA PREENCHER OS CAMPOS COM OS DADOS DO USUÁRIO
        if (dados.nome && document.getElementById('nome')) {
            document.getElementById('nome').value = dados.nome;
        }
        if (dados.email && document.getElementById('email')) {
            document.getElementById('email').value = dados.email;
        }
        if (dados.cpf && document.getElementById('cpf')) {
            document.getElementById('cpf').value = dados.cpf;
        }
        if (dados.celular && document.getElementById('celular')) {
            document.getElementById('celular').value = dados.celular;
        }
    }      

    async function teste_submit(){  // FUNÇÃO PARA VERIFICAR SE O PEDIDO PODE SER SUBMETIDO NO DB
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Enviar Pedido' DESSE COMPONENTE

        if(!disabledbtn){  // CASO O BOTÃO AINDA ESTEJA CLICKÁVEL
            setDisabledbtn(true)  // DEFINE O ESTADO DELE PARA IMPEDIR PEDIDOS REPETIDOS POR DOUBLECLICKS ACIDENTAIS
            document.getElementById('btn-checkout').classList.add('disabled')

            // MONTA O DICIONÁRIO COM AS INFORMAÇÕES QUE DEVEM SER ENVIADAS
            var dict_inputs = {'loja': sessionStorage['loja'], 'login': sessionStorage['login'], 'itens': window.itens}

            var inputs = document.getElementsByTagName('input')
            var selects = document.getElementsByTagName('select')

            for (var i = 0; i < inputs.length; i++){  // PARA TODOS OS INPUTS DE TEXTO
                inputs[i].classList.remove('border-erro')  // REMOVE ERROS ANTERIORES
            }
            for (i = 0; i < selects.length; i++){  // PARA TODOS OS INPUTS DE SELECT
                selects[i].classList.remove('border-erro')  // REMOVE ERROS ANTERIORES
            }        

            var submit = true

            for (i = 0; i < inputs.length; i++){  // PARA CADA INPUT DE TEXTO
                var campo_correto = true
                if(inputs[i].value === ""){  // VERIFICA SE O CAMPO ESTÁ VAZIO
                    campo_correto = false  // CASO ESTIVER VAZIO, NÃO SUBMETE
                }
                if (inputs[i].placeholder !== ""){  // VERIFICA SE EXISTEM DIGITOS FALTANDO
                    if (inputs[i].value.includes('_')){  // E TAMBÉM NÃO SUBMETE
                        campo_correto = false
                    }
                }

                if(!campo_correto){  // CASO CAMPO ESTIVER ERRADO
                    inputs[i].classList.add('border-erro')  // APONTA ERRO
                }            
                else{  // CASO ESTIVER CORRETO
                    dict_inputs[inputs[i].id] = inputs[i].value  // ADICIONA NO DICIONÁRIO DE INFORMAÇÕES
                }

                submit = submit && campo_correto
            }
        
            for (i = 0; i < selects.length; i++){  // PARA CADA INPUT DE SELECT
                campo_correto = true
                if(selects[i].value === "---------"){  // SE ESTIVER VAZIO
                    campo_correto = false  // NÃO SUBMETE
                    selects[i].classList.add('border-erro')  // E APONTA ERRO
                }
                else{  // SE ESTIVER CORRETO
                    dict_inputs[selects[i].id] = selects[i].value  // ADICIONA NO DICIONÁRIO DE INFORMAÇÕES
                }

                submit = submit && campo_correto
            }          

            if (submit){  // SE TODOS OS CAMPOS ESTÃO PREENCHIDOS
                submit_form(dict_inputs)  // SUBMETE AS INFORMAÇÕES NO DB
            }
            else{  // CASO NÃO SEJA POSSÍVEL SUBMETER
                console.log('Campos obrigatórios não preenchidos')
                setDisabledbtn(false)  // PERMITE QUE O USUÁRIO TENTE DE NOVO
                document.getElementById('btn-checkout').classList.remove('disabled')                        
            }
        }
    }

    async function submit_form(dict_inputs){  // FUNÇÃO PARA ENVIAR OS DADOS PARA O DB
        // FUNÇÃO CHAMADA CASO SEJA POSSÍVEL SUBMETER PELA FUNÇÃO 'teste_submit' DESSE COMPONENTE
    
        var resp = await api.post('checkout',{  // SUBMETE AS INFORMAÇÕES NO DB
            dict_inputs
            }).then((response) => {
                return response
            })     
        // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
         // 'data' ->  BOOLEANO QUE INDICA SE O PEDIDO FOI FINALIZADO COM SUCESSO
         // 'msg' -> STRING DE ERRO CASO 'data' SEJA FALSO
           
        if(resp['data']['data']){  // SE O PEDIDO FOI REALIZADO COM SUCESSO
            document.getElementById('infos_cartao').classList.add('d-none')  // SOME O CARD COM INFORMAÇÕES
            document.getElementById('sucesso').classList.remove('d-none')  // E APARECE O CARD DE SUCESSO
            document.getElementById('erro').innerText = ''  // LIMPA MENSAGENS DE ERRO
        }
        else{  // CASO O PEDIDO NÃO TENHA SIDO PROCESSADO
            document.getElementById('erro').innerText = resp['data']['msg']  // INDICA AO USUÁRIO O PORQUÊ
            setDisabledbtn(false)  // PERMITE TENTAR NOVAMENTE
            document.getElementById('btn-checkout').classList.remove('disabled')
        }

    }

    async function busca_endereco(){  // FUNÇÃO PARA AUTO-COMPLETE DO ENDEREÇO A PARTIR DO CEP
        // FUNÇÃO CHAMADA NA ALTERAÇÃO DO VALOR DO INPUT DE 'cep' DESSE COMPONENTE

        var cep = document.getElementById('cep').value

        if(!cep.includes('_')){  // CASO O CEP ESTEJA COMPLETO
            var url = "http://viacep.com.br/ws/" + cep + "/json/"  // CHAMA A FUNÇÃO EXTERNA
            
            jQuery.ajax({
                url: url,
                dataType:'json',
                type: 'get',
                success:function(response){
                    if (response.erro){  // SE DEU ERRO  
                        document.getElementById('estado').value = '---------'  // APAGA ENDEREÇO ANTERIOR
                        document.getElementById('cidade').value = ''
                        document.getElementById('endereco_1').value = ''
                        document.getElementById('endereco_2').value = ''
                    }
                    else{  // SE DEU CERTO
                        document.getElementById('estado').value = response.uf  // COMPLETA AS INFORMAÇÕES
                        document.getElementById('cidade').value = response.localidade
                        var endereco = response.logradouro
                        if (response.complemento.split('')[0] === '('){
                            endereco = endereco + ' ' + response.complemento
                        }
                        document.getElementById('endereco_1').value = endereco
                        document.getElementById('endereco_2').value = response.bairro
                    }
                },
                error:function(){  // SE A REQUISIÇÃO DEU ERRO
                    document.getElementById('estado').value = '---------'  // APAGA ENDEREÇO ANTERIOR
                    document.getElementById('cidade').value = ''
                    document.getElementById('endereco_1').value = ''
                    document.getElementById('endereco_2').value = ''
                }
            });

        }
    }

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
        // 'MaskedInput' -> COMPONENTE NATIVO DO REACT PARA REALIZAR A MASCARA DE CPF E TELEFONE

    return(
        <div>
            
        <p class="preco verde montserrat mt-3 mb-0 pb-2 font-x-larger px-5 border-bottom">Informações Pessoais</p>
        <div class="border-bottom-black p-4">
            <div class='col col-12 row px-0 mx-0 mb-3'>
                <div class="col-6 py-0 px-2 mx-0">
                    <h5 class='montserrat verde'>Nome Completo</h5>
                    <input id='nome' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                </div>
                <div class="col-6 px-2 py-0 mx-0">
                    <h5 class='montserrat verde'>CPF</h5>
                    <MaskedInput
                      mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                      className="w-100 no-outline busca border-redonda tamanho-filtro px-2"
                      placeholder="xxx.xxx.xxx-xx"
                      id="cpf"
                    />                      
                </div>    
            </div>
            <div class="col col-12 row px-2 py-0 mx-0">            
                <div class="col-6 p-0 mx-0">
                    <h5 class='montserrat verde'>Telefone Celular</h5>
                    <MaskedInput
                      mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                      className="w-100 no-outline busca border-redonda tamanho-filtro px-2"
                      placeholder="(xx) xxxxx-xxxx"
                      id="telefone"
                    />                    
                </div>
                <div class="col-6 py-0 px-2 mx-0">
                    <h5 class='montserrat verde'>Data de Nascimento</h5>
                    <input id='nascimento' type='date' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                </div>                
            </div>
        </div>

        <p class="preco verde montserrat mt-3 mb-0 pb-2 font-x-larger px-5 border-bottom">Endereço</p>

        <div class="border-bottom-black p-4">
            <div class="col-12 p-0 mx-0 row col mb-3">
                <div class="col-3 p-0">
                    <h5 class='montserrat verde'>CEP</h5>
                    <MaskedInput
                      mask={[/\d/, /\d/,  /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                      className="w-100 no-outline busca border-redonda tamanho-filtro px-2"
                      placeholder="xxxxx-xxx"
                      onChange={busca_endereco}
                      id="cep"
                    />                      
                </div>  
                <div class="col-3 px-3 py-0">
                    <h5 class='montserrat verde'>Estado</h5>
                    <select id='estado' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'>
                        <option selected disabled>---------</option>
                        <option>AC</option>
                        <option>AL</option>
                        <option>AP</option>
                        <option>AM</option>
                        <option>BA</option>
                        <option>CE</option>
                        <option>DF</option>
                        <option>ES</option>
                        <option>GO</option>
                        <option>MA</option>
                        <option>MT</option>
                        <option>MS</option>
                        <option>MG</option>
                        <option>PA</option>
                        <option>PB</option>
                        <option>PR</option>
                        <option>PE</option>
                        <option>PI</option>
                        <option>RJ</option>
                        <option>RN</option>
                        <option>RS</option>
                        <option>RO</option>
                        <option>RR</option>
                        <option>SC</option>
                        <option>SP</option>
                        <option>SE</option>
                        <option>TO</option>
                    </select>
                </div>
                <div class="col-6 p-0">
                    <h5 class='montserrat verde'>Cidade</h5>
                    <input id='cidade' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                </div>          
            </div>

            <div class="col-12 p-0 mx-0">
                <h5 class='montserrat verde'>Endereço</h5>
                <div class="row col col-12 mx-0">
                    <div class='col-md-10 col-9 mx-0 px-0'>
                        <input id="endereco_1" class='w-100 no-outline busca border-redonda tamanho-filtro px-2' placeholder="Rua ou Caixa Postal"></input>
                    </div>
                    <div class="col-md-2 col-3 mx-0 pr-0 pl-3">
                        <input id='numero' class="w-100 no-outline busca border-redonda tamanho-filtro px-2" placeholder="Número"></input>
                    </div>
                </div>
                <input id="endereco_2" class='w-100 no-outline busca border-redonda tamanho-filtro px-2 mt-1' placeholder="Apartamento, Suíte, Unidade, Edifício, Andar, Etc..."></input>
            </div>
        </div>


        <div class="my-4">
            <div class='col col-12 row px-2 mx-0'>
                <div class="row px-2 mx-0">
                    <div class='col-5 px-0 font-x-larger montserrat vermelha' id='erro'></div>
                    <div class='col-7 pull-right px-0'> 
                        <button class="d-flex align-items-center btn-verde pull-right row col col-12 px-0 mx-0" id='btn-checkout' onClick={teste_submit}>
                            <i class="col-3 fa fa-check montserrat" id='check-checkout'></i>
                            <div class='col-3 d-none' id='loader-checkout'>
                                <div class="loader-checkout montserrat"></div>
                            </div>
                            <div class='col-9'>
                                Enviar Pedido
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        </div>
    )
}

export default FormCartao